import React from 'react';

import Auth from './view/auth/route';

const route = {};
route['auth'] = Auth;

export default route;
